import Vue from 'vue'
import Router from 'vue-router'
import { checkPermission } from '@/common/utils/permission.js'

Vue.use(Router)

const defaultRoutes = [
  {
    path: '/login',
    component: (resolve) => require(['@/views/login/login'], resolve),
    hidden: true
  },
  {
    path: '/',
    component: (resolve) => require(['@/views/login/login'], resolve),
    hidden: true
  },
  {
    path: '/404',
    component: (resolve) => require(['@/views/error/404'], resolve),
    hidden: true
  },
  {
    path: '/401',
    component: (resolve) => require(['@/views/error/401'], resolve),
    hidden: true
  },
  {
    path: '/smart_situation',
    component: (resolve) => require(['@/views/smart_situation/smart_situation'], resolve),
    hidden: true,
    meta: {
        title: '智慧态势',
        code:'smart_situation',
    },
  },
  {
    path: '/statistical_summary',
    component: (resolve) => require(['@/views/home_management/statisticalSummary'], resolve),
    hidden: true,
    meta: {
        title: '统计汇总',
    },
  },
]

//解决ElementUI导航中的重复点菜单报错问题
const originalPush = Router.prototype.push
Router.prototype.push = function push(location){
  return originalPush.call(this,location).catch(err=>err)
}

import SysSettingRoutes from './module/system_setting'
import ActivitiesSysSettingRoutes from './module/activities_system_setting'
import gridManagement from './module/grid_management'
import infoManagement from './module/information_management'
import partyManagement from './module/party_management'
import homeManagement from './module/home_management'
import dutyManagement from './module/duty_management'
import creditManagement from './module/credit_management'

const routes = new Set([...defaultRoutes,...SysSettingRoutes,...ActivitiesSysSettingRoutes,...gridManagement,...infoManagement,...partyManagement,...homeManagement,...dutyManagement,...creditManagement])

const router = new Router({
  //mode: 'history',
  base: process.env.BASE_URL,     //配置单页应用的基础路径
  routes
})

const whiteRouter = ['/','/login','/401','/404','/statistical_summary']
// const mobileRouterByToken = ['/police_center','/app_promotion','/app_promotion_list','/401','/404']
//路由拦截  需要校验权限问题   后期直接从后台回去路由配置动态添加则无须校验
router.beforeEach(async (to, from, next) => {
    // next()
    // return
    if(whiteRouter.indexOf(to.path) != -1){
      next()
    }else{
      const token = sessionStorage.getItem('token')
      // console.log(token)
      if(token){
        if(to.meta.code != null && to.meta.code != ''){     //表示需要校验权限
          const permissions = JSON.parse(sessionStorage.getItem('permissionsList'))
          if(permissions != null && permissions.length > 0){
            if(!checkPermission(to.meta.code)){
              next({
                path:'/401'
              })
            }else{
              next()
            }
          }else{
            next({
              path:'/401'
            })
          }
          return
        }else{
          next({
            path:'/401'
          })
        }
      }else{
        next({
          path:'/login'
        })
      }

    }

  //let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)

  // if (to.meta.title) {
  //   document.title = i18n.t(to.meta.title) //to.meta.title
  // }
  // if(flag){
  //   if(mobileRouter.indexOf(to.path) != -1){
  //     next()
  //   }else{
  //     next({
  //       path:'/401'
  //     })
  //   }
  // }else{
  //   if(whiteRouter.indexOf(to.path) != -1){
  //     next()
  //   }else{
  //     if(to.meta.code != null && to.meta.code != ''){     //表示需要校验权限
  //       const permissions = JSON.parse(sessionStorage.getItem('permissionsList'))
  //       if(permissions != null && permissions.length > 0){
  //         if(!checkPermission(to.meta.code)){
  //           next({
  //             path:'/401'
  //           })
  //         }else{
  //           next()
  //         }
  //       }else{
  //         next({
  //           path:'/401'
  //         })
  //       }
  //       return
  //     }else{
  //       next({
  //         path:'/401'
  //       })
  //     }
  //   }
  // }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js